import SuiTypography from "components/SuiTypography";
import Tooltip from "@mui/material/Tooltip";
import TagItem from "containers/TagItem";
import Checkbox from "./Checkbox";
import { globaleDateTimeFormatter } from "utils/helper";
import TableAction from "containers/table-action";
import ApprovalToggle from "../DietRow/ApprovalToggle";
import CopyDietLinkButton from "components/ShareLink/CopyDietLinkButton";
import Chip from "@mui/material/Chip";
import { LAYOUT_VARIANT_PER_DAY } from "utils/perDayDietChart";
// import { useSelector } from "react-redux";
export const dietChartRow = (
  dietChartArrayv1,
  editHandler,
  deleteHandler,
  setChartArray,
  selectHandler,
  viewHandler,
  approveCheckHandler,
  uid,
  chartArray,
  clientData = null
) => {
  const sumPerDayPlansCalories = (item) => {
    if (item.layoutVariant !== LAYOUT_VARIANT_PER_DAY || !item.dayPlans) {
      return null;
    }
    let calories = 0;
    Object.values(item.dayPlans).forEach((dayObj) => {
      if (!dayObj) return;
      Object.values(dayObj).forEach((arr) => {
        if (!Array.isArray(arr)) return;
        arr.forEach((r) => {
          const c = parseFloat(r?.calories);
          if (!isNaN(c)) calories += c;
        });
      });
    });
    return calories;
  };

  const countCalories = (item) => {
    const perDayTotal = sumPerDayPlansCalories(item);
    if (perDayTotal !== null) {
      return perDayTotal.toFixed(2);
    }
    let calories = 0;
    item?.earlyMorning?.map((i) => {
      calories += isNaN(i?.calories) ? 0 : i?.calories;
      return i;
    });

    item?.breakfast?.map((i) => {
      calories += isNaN(i?.calories) ? 0 : i?.calories;
      return i;
    });

    item?.midMorning?.map((i) => {
      calories += isNaN(i?.calories) ? 0 : i?.calories;
      return i;
    });

    item?.midMeal?.map((i) => {
      calories += isNaN(i?.calories) ? 0 : i?.calories;
      return i;
    });

    item?.brunch?.map((i) => {
      calories += isNaN(i?.calories) ? 0 : i?.calories;
      return i;
    });

    item?.lunch?.map((i) => {
      calories += isNaN(i?.calories) ? 0 : i?.calories;
      return i;
    });

    item?.postLunch?.map((i) => {
      calories += isNaN(i?.calories) ? 0 : i?.calories;
      return i;
    });

    item?.evening?.map((i) => {
      calories += isNaN(i?.calories) ? 0 : i?.calories;
      return i;
    });

    item?.beforeDinner?.map((i) => {
      calories += isNaN(i?.calories) ? 0 : i?.calories;
      return i;
    });

    item?.dinner?.map((i) => {
      calories += isNaN(i?.calories) ? 0 : i?.calories;
      return i;
    });

    item?.postDinner?.map((i) => {
      calories += isNaN(i?.calories) ? 0 : i?.calories;
      return i;
    });

    item?.lateNight?.map((i) => {
      calories += isNaN(i?.calories) ? 0 : i?.calories;
      return i;
    });

    item?.lateDinner?.map((i) => {
      calories += isNaN(i?.calories) ? 0 : i?.calories;
      return i;
    });

    return calories?.toFixed(2) ?? 0;
  };

  const getDietRecipes = (item) => {
    setChartArray((e) => {
      return [...e, { dietChart: item }];
    });
  };

  const removeDietRecipes = (val) => {
    setChartArray((e) => {
      let recipeArr = e;
      recipeArr = recipeArr.filter((item) => {
        if (item.dietChart.dietChartId !== val.dietChartId) {
          return item;
        }
        return null;
      });
      return recipeArr;
    });
  };
  const rows = dietChartArrayv1.map((item, index) => {
    const startDate = new Date(item.from);
    const dietDate = new Date(startDate);
    dietDate.setDate(startDate.getDate() + index);
    return {
      "Mail & Download": (
        <Checkbox
          item={item}
          index={index}
          selectHandler={selectHandler}
          getDietRecipes={getDietRecipes}
          removeDietRecipes={removeDietRecipes}
          checked={item.selected}
          chartArray={chartArray}
        />
      ),
      Approve: (
        <ApprovalToggle
          item={item}
          index={index}
          approveHandler={approveCheckHandler}
        />
      ),

      "Date/Time (Added)": (
        <SuiTypography variant="button" fontWeight="medium">
          {globaleDateTimeFormatter(item?.createdAt)}
        </SuiTypography>
      ),

      "Diet Date for Client": (
        <SuiTypography variant="button" fontWeight="medium">
          {item?.from && item?.to
            ? `${globaleDateTimeFormatter(
                item?.from,
                "date"
              )} to ${globaleDateTimeFormatter(item?.to, "date")}`
            : item?.date
            ? globaleDateTimeFormatter(item?.date, "date")
            : "N/A"}
        </SuiTypography>
      ),

      "Week Plan": (
        <SuiTypography
          variant="button"
          fontWeight="medium"
          sx={{ display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap" }}
        >
          {item.layoutVariant === LAYOUT_VARIANT_PER_DAY && (
            <Chip size="small" label="Per-day" color="primary" variant="outlined" />
          )}
          {item.weekPlan}
        </SuiTypography>
      ),

      "Chart Type": (
        <SuiTypography variant="button" fontWeight="medium">
          {item.chartType}
        </SuiTypography>
      ),

      "Early Morning": item?.earlyMorning ? (
        <div>
          {item?.earlyMorning.map((i, index) => (
            <div key={index}>
              <Tooltip title={i?.description ?? ""} placement="top">
                <SuiTypography variant="button" fontWeight="medium">
                  {i?.description?.length > 40
                    ? `${i?.name} - ${i?.description?.slice(0, 40)}...`
                    : i?.name + " - " + i?.description}
                </SuiTypography>
              </Tooltip>
              {!isNaN(i?.calories) && <TagItem val={i?.calories} />}
            </div>
          ))}
        </div>
      ) : (
        <SuiTypography variant="button" fontWeight="medium">
          N/A
        </SuiTypography>
      ),

      Breakfast: item?.breakfast ? (
        <div>
          {item?.breakfast.map((i, index) => (
            <div key={index}>
              <Tooltip title={i?.description ?? ""} placement="top">
                <SuiTypography variant="button" fontWeight="medium">
                  {i?.description?.length > 40
                    ? `${i?.name} - ${i?.description?.slice(0, 40)}...`
                    : i?.name + " - " + i?.description}
                </SuiTypography>
              </Tooltip>
              {!isNaN(i?.calories) && <TagItem val={i?.calories} />}
            </div>
          ))}
        </div>
      ) : (
        <SuiTypography variant="button" fontWeight="medium">
          N/A
        </SuiTypography>
      ),

      "Mid Morning": item?.midMorning ? (
        <div>
          {item?.midMorning.map((i, index) => (
            <div key={index}>
              <Tooltip title={i?.description ?? ""} placement="top">
                <SuiTypography variant="button" fontWeight="medium">
                  {i?.description?.length > 40
                    ? `${i?.name} - ${i?.description?.slice(0, 40)}...`
                    : i?.name + " - " + i?.description}
                </SuiTypography>
              </Tooltip>
              {!isNaN(i?.calories) && <TagItem val={i?.calories} />}
            </div>
          ))}
        </div>
      ) : (
        <SuiTypography variant="button" fontWeight="medium">
          N/A
        </SuiTypography>
      ),

      Brunch: item?.brunch ? (
        <div>
          {item.brunch.map((i, index) => (
            <div key={index}>
              <Tooltip title={i?.description ?? ""} placement="top">
                <SuiTypography variant="button" fontWeight="medium">
                  {i?.description?.length > 40
                    ? `${i?.name} - ${i?.description?.slice(0, 40)}...`
                    : i?.name + " - " + i?.description}
                </SuiTypography>
              </Tooltip>
              {!isNaN(i?.calories) && <TagItem val={i?.calories} />}
            </div>
          ))}
        </div>
      ) : (
        <SuiTypography variant="button" fontWeight="medium">
          N/A
        </SuiTypography>
      ),

      "Mid Meal": item?.midMeal ? (
        <div>
          {item?.midMeal.map((i, index) => (
            <div key={index}>
              <Tooltip title={i?.description ?? ""} placement="top">
                <SuiTypography variant="button" fontWeight="medium">
                  {i?.description?.length > 40
                    ? `${i?.name} - ${i?.description?.slice(0, 40)}...`
                    : i?.name + " - " + i?.description}
                </SuiTypography>
              </Tooltip>
              {!isNaN(i?.calories) && <TagItem val={i?.calories} />}
            </div>
          ))}
        </div>
      ) : (
        <SuiTypography variant="button" fontWeight="medium">
          N/A
        </SuiTypography>
      ),

      Lunch: item?.lunch ? (
        <div>
          {item?.lunch.map((i, index) => (
            <div key={index}>
              <Tooltip title={i?.description ?? ""} placement="top">
                <SuiTypography variant="button" fontWeight="medium">
                  {i?.description?.length > 40
                    ? `${i?.name} - ${i?.description?.slice(0, 40)}...`
                    : i?.name + " - " + i?.description}
                </SuiTypography>
              </Tooltip>
              {!isNaN(i?.calories) && <TagItem val={i?.calories} />}
            </div>
          ))}
        </div>
      ) : (
        <SuiTypography variant="button" fontWeight="medium">
          N/A
        </SuiTypography>
      ),

      "Post Lunch": item?.postLunch ? (
        <div>
          {item?.postLunch.map((i, index) => (
            <div key={index}>
              <Tooltip title={i?.description ?? ""} placement="top">
                <SuiTypography variant="button" fontWeight="medium">
                  {i?.description?.length > 40
                    ? `${i?.name} - ${i?.description?.slice(0, 40)}...`
                    : i?.name + " - " + i?.description}
                </SuiTypography>
              </Tooltip>
              {!isNaN(i?.calories) && <TagItem val={i?.calories} />}
            </div>
          ))}
        </div>
      ) : (
        <SuiTypography variant="button" fontWeight="medium">
          N/A
        </SuiTypography>
      ),

      Evening: item?.evening ? (
        <div>
          {item?.evening.map((i, index) => (
            <div key={index}>
              <Tooltip title={i.description ?? ""} placement="top">
                <SuiTypography variant="button" fontWeight="medium">
                  {i?.description?.length > 40
                    ? `${i?.name} - ${i?.description?.slice(0, 40)}...`
                    : i?.name + " - " + i?.description}
                </SuiTypography>
              </Tooltip>
              {!isNaN(i?.calories) && <TagItem val={i?.calories} />}
            </div>
          ))}
        </div>
      ) : (
        <SuiTypography variant="button" fontWeight="medium">
          N/A
        </SuiTypography>
      ),

      "Before Dinner": item?.beforeDinner ? (
        <div>
          {item?.beforeDinner.map((i, index) => (
            <div key={index}>
              <Tooltip title={i?.description ?? ""} placement="top">
                <SuiTypography variant="button" fontWeight="medium">
                  {i?.description?.length > 40
                    ? `${i?.name} - ${i?.description?.slice(0, 40)}...`
                    : i?.name + " - " + i?.description}
                </SuiTypography>
              </Tooltip>
              {!isNaN(i?.calories) && <TagItem val={i?.calories} />}
            </div>
          ))}
        </div>
      ) : (
        <SuiTypography variant="button" fontWeight="medium">
          N/A
        </SuiTypography>
      ),

      Dinner: item?.dinner ? (
        <div>
          {item.dinner.map((i, index) => (
            <div key={index}>
              <Tooltip title={i?.description ?? ""} placement="top">
                <SuiTypography variant="button" fontWeight="medium">
                  {i.description?.length > 40
                    ? `${i.name} - ${i?.description?.slice(0, 40)}...`
                    : i?.name + " - " + i?.description}
                </SuiTypography>
              </Tooltip>
              {!isNaN(i?.calories) && <TagItem val={i?.calories} />}
            </div>
          ))}
        </div>
      ) : (
        <SuiTypography variant="button" fontWeight="medium">
          N/A
        </SuiTypography>
      ),

      "Post Dinner": item?.postDinner ? (
        <div>
          {item?.postDinner?.map((i, index) => (
            <div key={index}>
              <Tooltip title={i?.description ?? ""} placement="top">
                <SuiTypography variant="button" fontWeight="medium">
                  {i?.description?.length > 40
                    ? `${i?.name} - ${i?.description?.slice(0, 40)}...`
                    : i?.name + " - " + i?.description}
                </SuiTypography>
              </Tooltip>
              {!isNaN(i?.calories) && <TagItem val={i?.calories} />}
            </div>
          ))}
        </div>
      ) : (
        <SuiTypography variant="button" fontWeight="medium">
          N/A
        </SuiTypography>
      ),

      "Late Night": item?.lateNight ? (
        <div>
          {item?.lateNight.map((i, index) => (
            <div key={index}>
              <Tooltip title={i?.description ?? ""} placement="top">
                <SuiTypography variant="button" fontWeight="medium">
                  {i?.description?.length > 40
                    ? `${i?.name} - ${i?.description?.slice(0, 40)}...`
                    : i?.name + " - " + i?.description}
                </SuiTypography>
              </Tooltip>
              {!isNaN(i?.calories) && <TagItem val={i?.calories} />}
            </div>
          ))}
        </div>
      ) : (
        <SuiTypography variant="button" fontWeight="medium">
          N/A
        </SuiTypography>
      ),

      Notes: item?.notes ? (
        <Tooltip title={item?.notes ?? ""} placement="top">
          <SuiTypography variant="button" fontWeight="medium">
            {item?.notes?.length > 40
              ? `${item?.notes?.slice(0, 40)}...`
              : item?.notes}
          </SuiTypography>
        </Tooltip>
      ) : (
        <SuiTypography variant="button" fontWeight="medium">
          N/A
        </SuiTypography>
      ),

      Calories: (
        <SuiTypography variant="button" fontWeight="medium">
          <TagItem val={countCalories(item)} />
        </SuiTypography>
      ),

      Action: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <TableAction
            style={{ padding: "3px", marginLeft: "5px" }}
            updateHandler={() => editHandler(item, "diet")}
            viewHandler={() => viewHandler(item, "diet")}
            deleteHandler={() => {
              deleteHandler(item.dietChartId, "diet chart plan");
            }}
          />
          <CopyDietLinkButton uid={uid} dietChartId={item.dietChartId} />
        </div>
      ),
    };
  });
  return rows;
};
